import { useMemo, useRef } from 'react';
import { useCnRequest } from '@cainiaofe/cn-ui-utils';
export function useFetchDataService(props) {
    const dataSourceMapRef = useRef({});
    // @ts-ignore instance属性属于历史兼容逻辑
    const { instance, ...requestConfig } = props.requestConfig || {};
    const hasRequestConfig = Boolean(props.requestConfig);
    const config = useMemo(() => {
        if (!requestConfig)
            return {};
        return {
            defaultParams: {
                currentPage: 1,
                pageSize: 10,
            },
            ...requestConfig,
            method: requestConfig?.method || 'POST',
        };
    }, [requestConfig]);
    const { data, runAsync, loading } = useCnRequest(config);
    return useMemo(() => {
        if (!hasRequestConfig) {
            const refreshAsync = async () => { };
            const currentPageRefreshAsync = async () => { };
            const loadNextPage = async () => { };
            // @ts-ignore instance属性属于历史兼容逻辑,该逻辑后期会下线 start
            if (instance?.ref) {
                instance.ref.current.refresh = refreshAsync;
                instance.ref.current.load = currentPageRefreshAsync;
            }
            // end
            return {
                loading: !!hasRequestConfig,
                hasNextPage: false,
                refreshAsync,
                currentPageRefreshAsync,
                loadNextPage,
            };
        }
        const paging = data?.paging || {
            currentPage: 1,
            totalCount: data?.tableData?.length,
        };
        const { currentPage, totalCount } = paging;
        dataSourceMapRef.current[currentPage] = data?.tableData || [];
        const keys = Object.keys(dataSourceMapRef.current).sort((a, b) => Number(a) - Number(b));
        const dataSource = keys.reduce((result, key) => {
            return [...result, ...dataSourceMapRef.current[key]];
        }, []);
        const refreshAsync = async () => {
            dataSourceMapRef.current = {};
            await runAsync({ currentPage: 1, pageSize: 10 });
        };
        const currentPageRefreshAsync = async () => {
            await runAsync({ currentPage, pageSize: 10 });
        };
        const loadNextPage = async () => {
            await runAsync({ currentPage: currentPage + 1, pageSize: 10 });
        };
        if (instance?.ref) {
            instance.ref.current.refresh = refreshAsync;
            instance.ref.current.load = currentPageRefreshAsync;
        }
        // end
        return {
            loading,
            totalCount,
            hasNextPage: Boolean(totalCount && dataSource.length < totalCount),
            columns: data?.tableColumns || undefined,
            dataSource,
            refreshAsync,
            currentPageRefreshAsync,
            loadNextPage,
        };
    }, [hasRequestConfig, instance, data, loading, runAsync]);
}
